// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    display: flex;
    height: max-content;
    width: max-content;
    overflow: scroll;
    padding: 100vh 100vw 100vh 100vw;
    scrollbar-color: #888 #222;

    body {
        background: linear-gradient(#222, #001) fixed;
        color: #eee;
        font-family: "Source Code Pro", Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace;
        .explorer-sandwich:has(#explorer-filter-visible:checked) ~ .explorer-filters {
            transform: scaleX(1);
        }
        .explorer-filters {
            position: fixed;
            top: 0;
            left: 0;
            bottom: 0;
            --panning-sticky: sticky;
            --panning-visible: visible;
            visibility: var(--panning-visible);
            z-index: 10;
            display: flex;
            flex-direction: column;
            overflow: hidden;
            transform-origin: left;
            transition-delay: 3s;
            transition: transform 300ms linear;
            &:not(:hover):not(:focus-within) {
                transform: scaleX(0.0001);
            }
            .explorer-header{
                background: linear-gradient(hsla(24, 20%, 20%, .8), hsla(24, 20%, 50%, 1));;
                .kernel-explorer-title {
                    font-family: Oxanium, serif;
                    font-weight: 200;
                    padding-left: calc(25pt + 20px);
                    padding-right: 1em;
                    line-height: 25pt;
                }
            }
            .explorer-tabs {
                flex: 0 0 auto;
                background: #2d2d2ddd;
                border-bottom: 5px solid hsla(24, 20%, 40%, 1);
                label {
                    display: inline-block;
                    border-radius: 33% 33% 0 0;
                    background: hsla(24, 20%, 40%, 1);
                    padding: 5px 10px;
                    margin-top: 5px;
                    border-bottom: 1px solid black;
                    &:has(input:checked) {
                        border-bottom-color: hsla(24, 20%, 40%, 1);
                    }
                }
            }
            .explorer-panels {
                flex: 1 1 0;
                overflow: hidden;
                display: flex;
            }
            .explorer-tabs:has(.struct-explorer-tab:not(:checked)) ~ .explorer-panels .struct-explorer,
            .explorer-tabs:has(.file-explorer-tab:not(:checked)) ~ .explorer-panels .file-explorer {
                display: none;
            }
        }
        .explorer-sandwich {
            position: fixed;
            top: 0;
            left: 0;
            z-index: 100;
            margin: 6px 3px;
            --panning-visible: visible;
            visibility: var(--panning-visible);
            label {
                user-select: none;
                display: inline-block;
                font-size: 17pt;
                padding: 3px;
                border-radius: 50%;
                border: 1px solid #888;
                background: #222;
                height: 25pt;
                width: 25pt;
                margin: auto;
                line-height: 25pt;
                text-align: center;
                &:active:hover {
                    font-size: 15pt;
                    box-shadow: 0 0 16px 0 #ccc, 0 0 16px 0 #aaa;
                }
                &:hover {
                    font-size: 20pt;
                    box-shadow: inset 0 0 16px 0 #ccc, inset 0 0 16px 0 #aaa;
                }
            }
            input {
                appearance: none;
                width: 0;
                display: block;
            }
        }
        .code-explorer {
            z-index: 0;
        }
    }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;IAChC,0BAA0B;;IAE1B;QACI,6CAA6C;QAC7C,WAAW;QACX,yFAAyF;QACzF;YACI,oBAAoB;QACxB;QACA;YACI,eAAe;YACf,MAAM;YACN,OAAO;YACP,SAAS;YACT,wBAAwB;YACxB,0BAA0B;YAC1B,kCAAkC;YAClC,WAAW;YACX,aAAa;YACb,sBAAsB;YACtB,gBAAgB;YAChB,sBAAsB;YACtB,oBAAoB;YACpB,kCAAkC;YAClC;gBACI,yBAAyB;YAC7B;YACA;gBACI,0EAA0E;gBAC1E;oBACI,2BAA2B;oBAC3B,gBAAgB;oBAChB,+BAA+B;oBAC/B,kBAAkB;oBAClB,iBAAiB;gBACrB;YACJ;YACA;gBACI,cAAc;gBACd,qBAAqB;gBACrB,8CAA8C;gBAC9C;oBACI,qBAAqB;oBACrB,0BAA0B;oBAC1B,iCAAiC;oBACjC,iBAAiB;oBACjB,eAAe;oBACf,8BAA8B;oBAC9B;wBACI,0CAA0C;oBAC9C;gBACJ;YACJ;YACA;gBACI,WAAW;gBACX,gBAAgB;gBAChB,aAAa;YACjB;YACA;;gBAEI,aAAa;YACjB;QACJ;QACA;YACI,eAAe;YACf,MAAM;YACN,OAAO;YACP,YAAY;YACZ,eAAe;YACf,0BAA0B;YAC1B,kCAAkC;YAClC;gBACI,iBAAiB;gBACjB,qBAAqB;gBACrB,eAAe;gBACf,YAAY;gBACZ,kBAAkB;gBAClB,sBAAsB;gBACtB,gBAAgB;gBAChB,YAAY;gBACZ,WAAW;gBACX,YAAY;gBACZ,iBAAiB;gBACjB,kBAAkB;gBAClB;oBACI,eAAe;oBACf,4CAA4C;gBAChD;gBACA;oBACI,eAAe;oBACf,wDAAwD;gBAC5D;YACJ;YACA;gBACI,gBAAgB;gBAChB,QAAQ;gBACR,cAAc;YAClB;QACJ;QACA;YACI,UAAU;QACd;IACJ;AACJ","sourcesContent":[":root {\n    display: flex;\n    height: max-content;\n    width: max-content;\n    overflow: scroll;\n    padding: 100vh 100vw 100vh 100vw;\n    scrollbar-color: #888 #222;\n\n    body {\n        background: linear-gradient(#222, #001) fixed;\n        color: #eee;\n        font-family: \"Source Code Pro\", Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace;\n        .explorer-sandwich:has(#explorer-filter-visible:checked) ~ .explorer-filters {\n            transform: scaleX(1);\n        }\n        .explorer-filters {\n            position: fixed;\n            top: 0;\n            left: 0;\n            bottom: 0;\n            --panning-sticky: sticky;\n            --panning-visible: visible;\n            visibility: var(--panning-visible);\n            z-index: 10;\n            display: flex;\n            flex-direction: column;\n            overflow: hidden;\n            transform-origin: left;\n            transition-delay: 3s;\n            transition: transform 300ms linear;\n            &:not(:hover):not(:focus-within) {\n                transform: scaleX(0.0001);\n            }\n            .explorer-header{\n                background: linear-gradient(hsla(24, 20%, 20%, .8), hsla(24, 20%, 50%, 1));;\n                .kernel-explorer-title {\n                    font-family: Oxanium, serif;\n                    font-weight: 200;\n                    padding-left: calc(25pt + 20px);\n                    padding-right: 1em;\n                    line-height: 25pt;\n                }\n            }\n            .explorer-tabs {\n                flex: 0 0 auto;\n                background: #2d2d2ddd;\n                border-bottom: 5px solid hsla(24, 20%, 40%, 1);\n                label {\n                    display: inline-block;\n                    border-radius: 33% 33% 0 0;\n                    background: hsla(24, 20%, 40%, 1);\n                    padding: 5px 10px;\n                    margin-top: 5px;\n                    border-bottom: 1px solid black;\n                    &:has(input:checked) {\n                        border-bottom-color: hsla(24, 20%, 40%, 1);\n                    }\n                }\n            }\n            .explorer-panels {\n                flex: 1 1 0;\n                overflow: hidden;\n                display: flex;\n            }\n            .explorer-tabs:has(.struct-explorer-tab:not(:checked)) ~ .explorer-panels .struct-explorer,\n            .explorer-tabs:has(.file-explorer-tab:not(:checked)) ~ .explorer-panels .file-explorer {\n                display: none;\n            }\n        }\n        .explorer-sandwich {\n            position: fixed;\n            top: 0;\n            left: 0;\n            z-index: 100;\n            margin: 6px 3px;\n            --panning-visible: visible;\n            visibility: var(--panning-visible);\n            label {\n                user-select: none;\n                display: inline-block;\n                font-size: 17pt;\n                padding: 3px;\n                border-radius: 50%;\n                border: 1px solid #888;\n                background: #222;\n                height: 25pt;\n                width: 25pt;\n                margin: auto;\n                line-height: 25pt;\n                text-align: center;\n                &:active:hover {\n                    font-size: 15pt;\n                    box-shadow: 0 0 16px 0 #ccc, 0 0 16px 0 #aaa;\n                }\n                &:hover {\n                    font-size: 20pt;\n                    box-shadow: inset 0 0 16px 0 #ccc, inset 0 0 16px 0 #aaa;\n                }\n            }\n            input {\n                appearance: none;\n                width: 0;\n                display: block;\n            }\n        }\n        .code-explorer {\n            z-index: 0;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
